<template>
    <div v-if="show">
        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.BUG}.issue`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <input-simple
                    v-model="descriptionTemplate.issue"
                    :validate-option="{ name: 'issue', label: $t('label.issue') }"
                    input-class="grey4-grey4-background"
                />
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.BUG}.place`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <textarea-simple
                    v-model="descriptionTemplate.place"
                    :validate-option="{ name: 'place', label: $t('label.place') }"
                    textarea-class="grey4-grey4-background"
                />
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.BUG}.expectation`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <textarea-simple
                    v-model="descriptionTemplate.expectation"
                    :validate-option="{ name: 'expectation', label: $t('label.expectation') }"
                    textarea-class="grey4-grey4-background"
                />
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="fs-smaller grey1-grey1-color">
                {{ $t(`placeholder.${ISSUE_TYPE.BUG}.steps`) }}*
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <textarea-simple
                    v-model="descriptionTemplate.steps"
                    :validate-option="{ name: 'steps', label: $t('label.steps') }"
                    textarea-class="grey4-grey4-background"
                />
            </ion-col>
        </ion-row>

        <ion-row v-if="files.length > 0">
            <ion-col>
                <div class="mb-1 fw-b">
                    {{ $t('label.files') }}:
                </div>
                <div v-for="(file, counter) of files" :key="counter" class="mb-1">
                    {{ file.name }}
                </div>
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col size="auto" class="center">
                {{ $t('label.uploadImage') }}:
            </ion-col>
            <ion-col>
                <input-file
                    multiple
                    @change="emit('file', $event)"
                >
                    {{ $t('button.upload') }}
                </input-file>
            </ion-col>
        </ion-row>
    </div>
</template>

<script setup lang="ts">import { computed as _computed } from 'vue';

import { IonCol, IonRow, } from "@ionic/vue";
import { useForm } from "vee-validate";

import TextareaSimple from "@/components/input/TextareaSimple.vue";
import InputFile from "@/components/input/InputFile.vue";
import InputSimple from "@/components/input/InputSimple.vue";

import { FeedbackTicketTemplate } from "@/types/request";

import { ISSUE_TYPE } from "@/types/enum/general"
import { FeedbackBugProps } from "@/types/props";
import { FeedbackBugEmits } from "@/types/emits";

const props = defineProps<FeedbackBugProps>()
const emit = defineEmits<FeedbackBugEmits>()

const descriptionTemplate = _computed<FeedbackTicketTemplate>({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const { meta, resetForm, validate } = useForm({
    validationSchema: {
        issue: 'required',
        expectation: 'required',
        place: 'required',
        steps: 'required'
    }
})

defineExpose({
    meta,
    resetForm,
    validate
})
</script>
